import { formatDate } from "@fullcalendar/react";
import {
  Stack,
  Skeleton,
  Typography,
  styled,
  Box,
  Avatar,
  Paper,
  Divider,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { LessonStyle, Schedule } from "../../DAL/API";
import { getImageFromS3 } from "../../utils/storage";
import { ScheduleDatePanel } from "./ScheduleDatePanel";
import { ScheduleTimePanel } from "./ScheduleTimePanel";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

type Props = {
  schedule: Schedule;
  lessonStyle: LessonStyle;
};
export const ScheduleInfoPanel: React.FC<Props> = React.memo(
  ({ schedule, lessonStyle }) => {
    const [imagePath, setImagePath] = useState<string>("");
    useEffect(() => {
      getImageFromS3(schedule.lesson?.thumbnail!).then((result) =>
        setImagePath(result)
      );
    }, [schedule]);

    const reservationStatus = useMemo(() => {
      const capacity =
        lessonStyle === LessonStyle.STUDIO
          ? schedule.studio_capacity!
          : schedule.online_capacity!;
      const acceptableNumber =
        lessonStyle === LessonStyle.STUDIO
          ? schedule.acceptableStudioNumber!
          : schedule.acceptableOnlineNumber!;
      const ratio = acceptableNumber / capacity;
      if (ratio > 0) {
        return (
          <Stack direction="row" alignItems="center" spacing={0.3}>
            <CheckCircleOutlineIcon fontSize="small" color="success" />
            <Typography variant="body2">予約可</Typography>
          </Stack>
        );
      } else {
        return (
          <Stack direction="row" alignItems="center" spacing={0.3}>
            <ErrorOutlineIcon fontSize="small" color="error" />
            <Typography variant="body2">満員</Typography>
          </Stack>
        );
      }
    }, [schedule, lessonStyle]);
    return (
      <Paper variant="outlined">
        <Stack spacing={2.5} p={1.5}>
          <Stack spacing={2.5}>
            <Stack spacing={1.5} px={0.3}>
              <Stack
                direction="row"
                spacing={1.5}
                alignItems="center"
                justifyContent="stretch"
              >
                {imagePath !== "" ? (
                  <Avatar alt="lessonImage" src={imagePath} />
                ) : (
                  <Skeleton variant="circular" />
                )}

                <Stack spacing={0.7}>
                  <Typography variant="h3" fontWeight={600}>
                    {schedule.lesson.name}
                  </Typography>

                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>{reservationStatus}</Box>
                  </Stack>
                </Stack>
              </Stack>

              <Stack spacing={1}>
                <ScheduleDatePanel start={schedule.start} />
                <ScheduleTimePanel
                  startTime={schedule.start}
                  endTime={schedule.end}
                />
              </Stack>
            </Stack>
          </Stack>

          <Divider variant="middle" />
          <Box>
            <Typography variant="body1">
              {schedule.lesson.description}
            </Typography>
          </Box>
        </Stack>
      </Paper>
    );
  }
);
